var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-tooltip-content q-tooltip animate-scale",style:(_vm.transformCSS),attrs:{"role":"tooltip"}},[_c('a',{ref:"closeButton",staticClass:"tooltip-closer-btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }